/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ForwardTraceOrder } from '../../models/forward-trace-order';

export interface GetSimpleForwardSearch$Params {
  searchText?: string;
  startDate?: string;
  endDate?: string;
}

export function getSimpleForwardSearch(http: HttpClient, rootUrl: string, params?: GetSimpleForwardSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ForwardTraceOrder>>> {
  const rb = new RequestBuilder(rootUrl, getSimpleForwardSearch.PATH, 'get');
  if (params) {
    rb.query('searchText', params.searchText, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ForwardTraceOrder>>;
    })
  );
}

getSimpleForwardSearch.PATH = '/api/v1/getSimpleForwardSearch';
